import * as React from 'react';
import { ModalView } from '@cian/ui-kit/prev';
import { Button } from '@cian/button-component';
import * as styles from './index.css';

const successIcon = require('./success.svg') as string;

export interface IEntryToShowSuccessModalProps {
  isOpen: boolean;
  closeModal(): void;
}

export const EntryToShowSuccessModal = ({ isOpen, closeModal }: IEntryToShowSuccessModalProps) => {
  return (
    <ModalView onClose={closeModal} custom={{ open: isOpen, mediaType: 'desktop' }}>
      <div className={styles['container']}>
        <img src={successIcon} />
        <h1 className={styles['title']}>Поздравляем!</h1>
        <div className={styles['text']}>Вы записались на просмотр</div>
        <Button onClick={closeModal}>Хорошо</Button>
      </div>
    </ModalView>
  );
};
